'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoSocialDesignernews = function IoSocialDesignernews(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20.2 11.3l0 4.2-5-8z m3-3.8l11.8 9.2v15.8h-19.4l-15.6-12.3h4.9c3.6 0 6-2.5 6-6.4 0-1.5-0.4-2.9-1.1-4l-0.3-0.2 2.9 2.3v8.3h3.1l-0.1-7.7 5 7.7h2.8v-12.7z m-15.5 6.4c0 2.2-1.1 3.4-3.2 3.4h-1.5v-6.9h1.5c2.1 0 3.2 1.2 3.2 3.5z' })
        )
    );
};

exports.default = IoSocialDesignernews;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/social-designernews.js
// module id = 2665
// module chunks = 0